import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("06 串列設計主檔")]), _vm._v(" —— 每串的模組規格、方位、傾角。串列同儕分群與串列 RA 現算都靠這張。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("同儕分群依據")]), _vm._v("：模組型號 + 瓦數 + 方位角 + 傾角 + 串接片數，五個全同才算同儕。 同儕群組代號留空就由引擎自己分，要強制分群才填。 ")]), _c('li', [_c('strong', [_vm._v("串列清單跟 05 要")]), _vm._v("：按「由MPPT串列對應產生」，05 裡有接的每一串長一列， 規格填一次整批套上，不一樣的幾串之後再用「一鍵填入」改。所以"), _c('strong', [_vm._v("先建 05、再建這頁")]), _vm._v("。 ")]), _c('li', [_vm._v(" 索引一律照 05，"), _c('strong', [_vm._v("不要照抄 Excel 06 的索引")]), _vm._v(" —— v3 的 06 跟 05 一樣把空接往前遞補， f001 INV1 從第 6 串起整排錯一格。 ")]), _c('li', [_vm._v("串列容量 = 瓦數 × 片數 ÷ 1000，DB 自動算，改了瓦數或片數會跟著變。")])])]), _c('div', {
    staticClass: "px-2 pt-2"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info",
      "disabled": !_vm.siteCode,
      "title": "拿主檔 05 有接的串當清單，規格填一次整批寫入"
    },
    on: {
      "click": function click($event) {
        _vm.open = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-project-diagram"
  }), _vm._v(" 由MPPT串列對應產生 ")])], 1), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "string_design",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners)), _c('b-modal', {
    attrs: {
      "title": "由 MPPT串列對應產生串列設計",
      "size": "lg",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.rows.length
    },
    on: {
      "show": _vm.onShow,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.open,
      callback: function callback($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_vm.loadError ? _c('b-alert', {
    staticClass: "py-2 sd_hint",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.loadError))]) : !_vm.loading && !_vm.rows.length ? _c('b-alert', {
    staticClass: "py-2 sd_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.siteCode) + " 的主檔 05 沒有任何有接的串，先去「MPPT串列對應」分頁建。 ")]) : _c('div', {
    staticClass: "sd_hint mb-2"
  }, [_vm._v(" 主檔 05 有接的串共 "), _c('strong', [_vm._v(_vm._s(_vm.rows.length))]), _vm._v(" 串（空接不建列）。 "), _vm.existing ? [_vm._v(" 已經有 " + _vm._s(_vm.existing) + " 列，寫入時"), _c('strong', [_vm._v("已存在的位置會略過、不覆蓋")]), _vm._v("。 ")] : _vm._e()], 2), _vm._l(_vm.specColumns, function (c) {
    return _c('b-form-group', {
      key: c.name,
      staticClass: "mb-2",
      attrs: {
        "label": c.label + (c.required ? ' *' : ''),
        "description": c.hint,
        "label-cols-md": "3",
        "label-size": "sm"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "type": c.type === 'text' || c.type === 'date' ? c.type : 'number',
        "step": c.type === 'int' ? 1 : 'any',
        "maxlength": c.maxLength
      },
      model: {
        value: _vm.spec[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.spec, c.name, $$v);
        },
        expression: "spec[c.name]"
      }
    })], 1);
  }), _vm.capacity ? _c('div', {
    staticClass: "sd_hint"
  }, [_vm._v("每串容量 " + _vm._s(_vm.capacity) + " kWp，全場 " + _vm._s((_vm.capacity * _vm.rows.length).toFixed(2)) + " kWp。")]) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "py-2 mb-0 mt-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };